export default class I18n {
  static get locale () {
    return 'en-US'
  }

  static get currencyFormatter () {
    if (!this._currencyFormatter) {
      this._currencyFormatter = new Intl.NumberFormat(this.locale, {
        style: 'currency',
        currency: 'USD'
      })
    }

    return this._currencyFormatter
  }

  static numberToCurrency (number) {
    return this.currencyFormatter.format(number || 0)
  }

  static zeroPaddedNumber (number, minimumDigits) {
    let str = ''
    let temporary = (number > 0 ? number : 1) / Math.pow(10, minimumDigits - 1)

    while (temporary < 1) {
      str = str + '0'
      temporary = temporary * 10
    }

    return str + number
  }
}
